module.exports = __webpack_public_path__ + "img/5@3x.3fac5403.png";